import React__default, { useRef, useMemo, useCallback } from 'react';
import { ResizeableCombo } from './components/ResizeableCombo/ResizeableCombo.mjs';
import { Combo } from './components/Combo/Combo.mjs';
import { Editor } from './components/Editor/Editor.mjs';

function RichTextEditor({
  editor,
  onChange,
  onSelectionChange,
  plugins,
  resizeable,
  selection,
  title,
  toolbar,
  value,
  fullWidth = false,
  unframed = false,
  hideFocusRing = false,
  readOnly = false,
  tone,
  ...extraneousProps
}) {
  const editorRef = useRef(null);
  const pluginTypes = useMemo(() => plugins.map(({
    type
  }) => type).join(), [plugins]);
  const renderEditor = useCallback((children, {
    focused
  }) => {
    var _editorRef$current;
    const props = {
      toolbar,
      focused,
      children,
      fullWidth,
      unframed,
      hideFocusRing,
      readOnly,
      tone
    };
    return resizeable && title ? /*#__PURE__*/React__default.createElement(ResizeableCombo, Object.assign({}, props, {
      title: title,
      onTransitionEnd: editorRef === null || editorRef === void 0 ? void 0 : (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.rerenderPopovers
    })) : /*#__PURE__*/React__default.createElement(Combo, props);
  }, [toolbar, fullWidth, unframed, hideFocusRing, readOnly, tone, resizeable, title]);
  return /*#__PURE__*/React__default.createElement(Editor, Object.assign({
    key: pluginTypes,
    ref: editorRef,
    editor: editor,
    plugins: plugins,
    selection: selection,
    value: value,
    readOnly: readOnly,
    onChange: onChange,
    onSelectionChange: onSelectionChange,
    renderEditor: renderEditor
  }, extraneousProps));
}

export { RichTextEditor };
